import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function PageContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'relative isolate container mx-auto flex flex-col gap-8 px-6 py-8 lg:px-10',
        className,
      )}
    >
      <div
        aria-hidden
        className='page-glow pointer-events-none absolute top-0 right-0 -z-10 h-72 w-[36rem] max-w-full'
      />
      {children}
    </div>
  );
}
